import { ContextTemplate, CreateContextTemplatePayload, UpdateContextTemplatePayload, PreviewContextTemplatePayload, PreviewContextTemplateResponse } from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

// Context Template API calls
export async function getContextTemplates(): Promise<ContextTemplate[]> {
  const response = await fetch(`${getApiBaseUrl()}/context-templates`);
  return handleResponse<ContextTemplate[]>(response);
}

export async function createContextTemplate(payload: CreateContextTemplatePayload): Promise<ContextTemplate> {
  const response = await fetch(`${getApiBaseUrl()}/context-templates`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<ContextTemplate>(response);
}

export async function updateContextTemplate(id: string, payload: UpdateContextTemplatePayload): Promise<ContextTemplate> {
  const response = await fetch(`${getApiBaseUrl()}/context-templates/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<ContextTemplate>(response);
}

export async function deleteContextTemplate(id: string): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/context-templates/${id}`, {
    method: 'DELETE',
  });
  await handleResponse<void>(response);
}

export async function duplicateContextTemplate(id: string): Promise<ContextTemplate> {
  const response = await fetch(`${getApiBaseUrl()}/context-templates/${id}/duplicate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<ContextTemplate>(response);
}

export async function setDefaultInitialContextTemplate(
  id: string,
): Promise<ContextTemplate> {
  const response = await fetch(
    `${getApiBaseUrl()}/context-templates/${id}/set-default-initial`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    },
  );
  return handleResponse<ContextTemplate>(response);
}

export async function setDefaultFollowupContextTemplate(
  id: string,
): Promise<ContextTemplate> {
  const response = await fetch(
    `${getApiBaseUrl()}/context-templates/${id}/set-default-followup`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    },
  );
  return handleResponse<ContextTemplate>(response);
}

export async function setDefaultCondensedContextTemplate(
  id: string,
): Promise<ContextTemplate> {
  const response = await fetch(
    `${getApiBaseUrl()}/context-templates/${id}/set-default-condensed`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    },
  );
  return handleResponse<ContextTemplate>(response);
}

export async function previewContextTemplate(
  payload: PreviewContextTemplatePayload,
): Promise<PreviewContextTemplateResponse> {
  const response = await fetch(`${getApiBaseUrl()}/context-templates/preview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<PreviewContextTemplateResponse>(response);
}